/**
 * Swap Provider Module Exports
 *
 * Provides hot-swappable swap aggregation for Jupiter, Titan Exchange, and others.
 *
 * Usage:
 *   import { getSwapProviderManager, JupiterSwapProvider, TitanSwapProvider } from './swap';
 *
 *   const manager = getSwapProviderManager({ rpcEndpoint: '...' });
 *   await manager.registerDefaults();
 *   await manager.setActiveProvider('jupiter');
 *
 *   // Get quotes
 *   const quotes = await manager.getQuote({
 *     inputMint: 'So11111111111111111111111111111111111111112',
 *     outputMint: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
 *     amount: 1000000000, // 1 SOL in lamports
 *     slippageBps: 50
 *   });
 *
 *   // Execute swap
 *   const result = await manager.executeSwap(quotes[0], wallet);
 */

export { SwapProvider, SwapQuote, SwapRouteStep } from './SwapProvider.js';
export { JupiterSwapProvider } from './JupiterSwapProvider.js';
export { TitanSwapProvider } from './TitanSwapProvider.js';
export {
    SwapProviderManager,
    getSwapProviderManager,
    resetSwapProviderManager
} from './SwapProviderManager.js';
